import { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUIStore } from '../../stores/useUIStore';

export default function RedirectHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const setShowNewChat = useUIStore((s) => s.setShowNewChat);
  const setInitialParamsForNewChat = useUIStore((s) => s.setInitialParamsForNewChat);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const telefone = queryParams.get('telefone');
    const msg = queryParams.get('msg');

    if (telefone && msg) {
      setInitialParamsForNewChat({ telefone, msg });
      setShowNewChat(true);
      navigate('/chat');
    } else {
      navigate('/');
    }
  }, [location.search,
    navigate,
    setShowNewChat,
    setInitialParamsForNewChat]);

  return null;
}
